import React from "react";
import "./brainstrome.css";
import BrainStromeLarge from "./image/brainStromeLarge.png";
import BrainStromeSmall from "./image/brainStromeSmall.png";
import BrainStromePhone from "./image/brainStromePhone.webp";
import BrainStromeDesktop from "./image/brainStromeDesktop.webp";

const BrainStrome = () => {
  return (
    <div className="brainstrome-content" id="our-process">
      <h1 className="heading-brainstrome">
        <span className="heading1-brainstrome">HOW WE</span>
        <span className="heading2-brainstrome"> BRAINSTROME TO BRILLIANCE</span>
      </h1>
      <img
        className="image-desktop"
        src={BrainStromeDesktop}
        alt="Image for large screen"
      />
      <img
        className="image-phone"
        src={BrainStromePhone}
        alt="Image for small screen"
      />
    </div>
  );
};
export default BrainStrome;
